var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"tool-bar",style:({marginBottom: _setup.bottomGap + 'px'})},[_c('el-space',{attrs:{"size":_setup.leftGapSize}},[_vm._t("default")],2),(_setup.hasRightSlot)?_c('div',[_c('el-space',{attrs:{"size":_setup.rightGapSize}},[_vm._t("right")],2)],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }